import Colors, { withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
const GalleryTheme = {
    gallery: {
        light: {
            peakOverlayColor: withOpacity(Colors.agatheGrey, Opacities.low),
            captions: {
                countColor: withOpacity(Colors.black, Opacities.medium),
                captionColor: withOpacity(Colors.black, Opacities.full),
            },
            states: {
                enabled: {
                    fixedButtonColor: withOpacity(Colors.white, Opacities.medium),
                    chevronColor: Colors.black,
                    indicatorColor: withOpacity(Colors.white, Opacities.low),
                    indicatorDotColor: withOpacity(Colors.black, Opacities.low),
                },
                hover: {
                    fixedButtonColor: Colors.white,
                    chevronColor: withOpacity(Colors.black, Opacities.medium),
                    indicatorColor: withOpacity(Colors.white, Opacities.medium),
                    indicatorDotColor: withOpacity(Colors.black, Opacities.medium),
                },
                selected: {
                    chevronColor: Colors.black,
                    indicatorColor: Colors.accessibleSafetyOrange,
                    indicatorDotColor: Colors.black,
                },
            },
        },
        dark: {
            captions: {
                countColor: withOpacity(Colors.white, Opacities.medium),
                captionColor: withOpacity(Colors.white, Opacities.full),
            },
            states: {
                enabled: {
                    fixedButtonColor: withOpacity(Colors.black, Opacities.medium),
                    chevronColor: Colors.white,
                    indicatorColor: withOpacity(Colors.white, Opacities.low),
                    indicatorDotColor: withOpacity(Colors.white, Opacities.low),
                },
                hover: {
                    fixedButtonColor: Colors.black,
                    chevronColor: withOpacity(Colors.white, Opacities.medium),
                    indicatorColor: withOpacity(Colors.white, Opacities.medium),
                    indicatorDotColor: withOpacity(Colors.white, Opacities.medium),
                },
                selected: {
                    chevronColor: Colors.white,
                    indicatorColor: Colors.accessibleSafetyOrange,
                    indicatorDotColor: Colors.white,
                },
            },
        },
    },
};
export default GalleryTheme;
